/**
 * Employee Incident Rejection Service
 * HTTP operations for the individual rejection of a marking incident
 * (ASIS-5248 / REXASIS-006)
 */
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_RejectIncidentIn, LC_RejectIncidentOut } from '../types';

/**
 * Service for rejecting an individual marking incident.
 */
export class EmployeeIncidentRejectService {
  /**
   * Reject a marking incident (ASIS-5248). Only the approver comment is
   * sent; the incident id comes from the route and the approver identity is
   * resolved on the backend (JWT). Always returns HTTP 200 with an `outcome`
   * discriminator: 'rejected' (success) or 'alreadyResolved' (concurrency,
   * carries the real currentState).
   * PUT /v1/attendances/incidents/{incidentId}/rejection
   */
  reject(
    incidentId: number,
    input: LC_RejectIncidentIn,
  ): Promise<ApiResponse<LC_RejectIncidentOut>> {
    return apiClient.put<LC_RejectIncidentOut>(
      API_CONFIG.ENDPOINTS.EMPLOYEE_INCIDENTS.REJECT_MANAGEMENT(incidentId),
      input,
    );
  }
}

export const employeeIncidentRejectService = new EmployeeIncidentRejectService();
